// Course modality: the boolean column on `courses` that offers it (ABRA-331).
export type TestimonialVideoModality = 'in_person' | 'live_online' | 'recorded'

export const MODALITY_LABELS: Record<TestimonialVideoModality, string> = {
  in_person: 'Presencial',
  live_online: 'EAD Ao Vivo',
  recorded: 'Online (videoaulas)'
}

export interface ITestimonialVideoCourseOption {
  id: number
  name: string
}

export interface ITestimonialVideoAddress {
  zip_code: string
  street: string
  number: string
  complement: string
  neighborhood: string
  city: string
  state: string
}

export interface ITestimonialVideoSubmission {
  id: number
  name: string
  email: string
  zip_code: string
  street: string
  number: string
  complement: string | null
  neighborhood: string
  city: string
  state: string
  modality: TestimonialVideoModality
  modality_label: string
  course_id: number
  course_name: string | null
  video_url: string | null
  video_original_name: string
  video_size: number
  consent_accepted_at: string
  consent_text: string
  consent_ip: string | null
  consent_user_agent: string | null
  created_at: string
  updated_at: string
}

/** A row of the listing: the index only ships what the table shows (the rest comes from show()). */
export type ITestimonialVideoListItem = Pick<
  ITestimonialVideoSubmission,
  | 'id'
  | 'created_at'
  | 'name'
  | 'email'
  | 'modality'
  | 'modality_label'
  | 'course_id'
  | 'course_name'
  | 'city'
  | 'state'
>

export interface ITestimonialVideoListParams {
  search?: string
  modality?: string
  course_id?: string
  date?: { start: string; end: string }
  page?: number
  page_size?: number
}

export interface ITestimonialVideoListResponse {
  recordsTotal: number
  recordsFiltered: number
  data: ITestimonialVideoListItem[]
}

export interface ITestimonialVideoUpdatePayload extends ITestimonialVideoAddress {
  name: string
  email: string
  modality: TestimonialVideoModality
  course_id: number
}
